import React from "react";

export default function ScrollToTop() {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollUp = () => window.scrollTo({ top: 0, behavior: "smooth" });

  if (!visible) return null;
  return (
    <button className="scroll-to-top" onClick={scrollUp} aria-label="Back to top">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 1L2 9h4.5v6h3V9H14L8 1z" fill="currentColor"/></svg>
    </button>
  );
}
